// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { ResponsiveTreeMap } from '@nivo/treemap';
import {
  formatAssetClassLabel,
  transformAssetClassData,
} from './utils/transform-asset-class-data';
import { ChartContainer } from '@shared/ui-kit/components';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface SegmentChartProps {
  categories: string[];
  percentage: number[];
}

export const SegmentChart: FC<SegmentChartProps> = ({ categories, percentage }) => {
  const { t } = useTranslation();
  const data = transformAssetClassData(categories, percentage, t);

  const dataLength = data?.children?.length;

  const label = formatAssetClassLabel(dataLength);

  return (
    <ChartContainer header={t('glossary.segment', { ns: 'glossary' })}>
      <ResponsiveTreeMap
        data={data}
        identity="name"
        value="percentage"
        valueFormat=" >-.2%"
        colors={({ data }) => data.color}
        margin={{ top: 20, right: 10, bottom: 10, left: 10 }}
        label={label}
        leavesOnly={true}
        labelSkipSize={75}
        labelTextColor="#FFFFFF"
        orientLabel={true}
        nodeOpacity={0.55}
        enableParentLabel={false}
        borderColor={{
          from: 'color',
          modifiers: [['darker', 0.1]],
        }}
        theme={{
          labels: {
            text: {
              fontSize: 13,
              fontFamily: 'poppins',
            },
          },
        }}
        animate={false}
      />
    </ChartContainer>
  );
};
